import { Capacitor } from "@capacitor/core"

/**
 * Tag the document root with a class so SCSS can opt into native vs web
 * behavior without each component reading `Capacitor.isNativePlatform()`.
 *
 * Apply this synchronously at app boot — before React renders — so styles
 * resolve correctly on first paint.
 */
if (
  Capacitor.isNativePlatform() &&
  typeof document !== "undefined" &&
  document.documentElement
) {
  document.documentElement.classList.add("is-native-platform")
}
